"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account_manager_abi__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "blsPubKey",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "encryptedBlsSigningKey",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "aesEncryptorKey",
                type: "bytes",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "depositContractRoot",
                type: "bytes32",
            },
        ],
        name: "CheckpointA",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "blsPubKey",
                type: "bytes",
            },
        ],
        name: "CheckpointB1",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "blsPubKey",
                type: "bytes",
            },
        ],
        name: "CheckpointB2",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "blsPubKey",
                type: "bytes",
            },
        ],
        name: "CheckpointB3",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "blsPubKey",
                type: "bytes",
            },
        ],
        name: "CheckpointB4",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "blsPubKey",
                type: "bytes",
            },
        ],
        name: "InitialsRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "BLOCK_DELTA",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accounts",
        outputs: [
            {
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "blsSignature",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "depositBlock",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "areInitialsRegistered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "blsPubKeyToAccountArrayIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "blsPublicKeyToLastState",
        outputs: [
            {
                internalType: "bytes",
                name: "blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "withdrawalCredentials",
                type: "bytes",
            },
            {
                internalType: "bool",
                name: "slashed",
                type: "bool",
            },
            {
                internalType: "uint64",
                name: "activeBalance",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "effectiveBalance",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "exitEpoch",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "activationEpoch",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "withdrawalEpoch",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "currentCheckpointEpoch",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "blsPublicKeyToLifecycleStatus",
        outputs: [
            {
                internalType: "enum IAccountManager.LifecycleStatus",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "claimedTokens",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_creator",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "string",
                name: "_ticker",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "_savETHIndexId",
                type: "uint256",
            },
        ],
        name: "createStakehouse",
        outputs: [
            {
                internalType: "address",
                name: "stakehouse",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "getAccount",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "depositor",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "blsSignature",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "depositBlock",
                        type: "uint256",
                    },
                ],
                internalType: "struct IAccountManager.Account",
                name: "userAccount",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "getAccountByPublicKey",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "depositor",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "blsSignature",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "depositBlock",
                        type: "uint256",
                    },
                ],
                internalType: "struct IAccountManager.Account",
                name: "account",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "getDepositBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "depositBlock",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "getLastKnownActiveBalance",
        outputs: [
            {
                internalType: "uint64",
                name: "lastActiveBalance",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "getLastKnownStateByPublicKey",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct ETH2Validation.ETH2DataReport",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "getLastReportEpoch",
        outputs: [
            {
                internalType: "uint64",
                name: "lastReportEpoch",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "getSignatureByBLSKey",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract StakeHouseUniverse",
                name: "_universe",
                type: "address",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "isKeyDeposited",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_applicant",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "string",
                name: "_ticker",
                type: "string",
            },
            {
                internalType: "address",
                name: "_stakehouse",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_savETHIndexId",
                type: "uint256",
            },
        ],
        name: "joinStakeHouseAndCreateBrand",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_applicant",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_stakehouse",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_brandTokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_savETHIndexId",
                type: "uint256",
            },
        ],
        name: "joinStakehouse",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
        ],
        name: "markKnotAsWithdrawn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "numberOfAccounts",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_rageQuitter",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_stakeHouse",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amountOfETHInDepositQueue",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct ETH2Validation.ETH2DataReport",
                name: "_report",
                type: "tuple",
            },
        ],
        name: "rageQuitKnot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_depositor",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_ciphertext",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_aesEncryptorKey",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "_depositContractRoot",
                type: "bytes32",
            },
        ],
        name: "registerDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_depositor",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_blsSignature",
                type: "bytes",
            },
        ],
        name: "registerValidatorInitials",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "setLifecycleExited",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "universe",
        outputs: [
            {
                internalType: "contract StakeHouseUniverse",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct ETH2Validation.ETH2DataReport",
                name: "_report",
                type: "tuple",
            },
        ],
        name: "updateAccountState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "uint64",
                name: "_exitEpoch",
                type: "uint64",
            },
        ],
        name: "updateExitEpochFromReport",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "uint64",
                name: "_updatedActiveBalance",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "_reportEpoch",
                type: "uint64",
            },
        ],
        name: "updateKnotActiveBalanceFromReport",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
            {
                internalType: "uint64",
                name: "_epoch",
                type: "uint64",
            },
        ],
        name: "updateSlashedIsTrueFromReport",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
class Account_manager_abi__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Account_manager_abi__factory = Account_manager_abi__factory;
Account_manager_abi__factory.abi = _abi;
